import ReactDOM from 'react-dom';
import React from 'react';
import { IOnlineMasteringPrice } from './interfaces';
import OnlineMasteringPrices from './online-mastering-prices';
import { getJSONFromHtml } from '../../../../domain/common';
import { YotpoReview } from '../../../../ui/rating/interfaces';

export const initOnlineMasteringPricing = () => {

    const $placeholder = document.getElementById('olm-prices');
    if(!$placeholder) {
        console.error('Element with id="olm-prices" is missing.');
        return;
    }

    const $data = document.getElementById('online-mastering-pricing-data');
    if(!$data) {
        console.error('Element with id="online-mastering-pricing-data" is missing.');
        return;
    }

    let prices: IOnlineMasteringPrice[] = [];

    try {
        prices = JSON.parse($data?.textContent ?? '');
    }
    catch (ex) {
        console.error('Parse data error', ex);
        return;
    }

    if(!prices?.length) {
        console.error('No prices found.');
        return;
    }

    const yotpoReviews = getJSONFromHtml(document.getElementById('star-rating-widget-data')) as YotpoReview[];

    ReactDOM.render(
        <React.StrictMode>
            <OnlineMasteringPrices
                prices={ prices }
                yotpoReviews={ yotpoReviews }
            />
        </React.StrictMode>,
        $placeholder,
    );
};